export enum ChannelType {
  MWSC = 'MWSC',
  OMNICHANNEL = 'OMNICHANNEL',
  PWSC = 'PWSC',
  XTV_FE_APPS = 'XTV_FE_APPS',
  MO2_CARE = 'MO2_CARE',
  O2TV_SC = 'O2TV_SC',
  SALESTOOL = 'SALESTOOL',
}
